<template>
  <!--  <div>{{ $route.params.id }}</div>-->
  <div class="application-info-container container">
    <div class="application-info-top">
      <div class="application-info-top-header">采购计划信息</div>
      <div class="application-info-top-content-container">
        <div class="application-info-top-content">
          <div>物料分类：{{ baseInfo.categoryName }}</div>
          <div>物料编码：{{ baseInfo.categoryCustomCode }}</div>
          <div>物料描述：{{ baseInfo.categoryDesc }}</div>
          <div>计量单位：{{ baseInfo.baseUnitName }}</div>
          <div>采购数量：{{ baseInfo.remainingQuantity }}</div>
          <div>概算单价：{{ baseInfo.budgetaryPrice }}</div>
          <div>期望到货日期：{{ baseInfo.expectedArrivalDate }}</div>
        </div>
      </div>
    </div>
    <div class="application-info-middle">
      <div class="application-info-middle-header">
        <div>商品选择</div>
        <div>
          根据筛选条件，为贵公司推荐
          <span>{{ queryParams.total }}</span>
          件商品
        </div>
      </div>
      <div class="wrapper">
        <div class="scroller_right">
          <span class="margin-t10">综合搜索：</span>
          <el-input
            v-model="productSearch.searchtext"
            class="scroller_input"
            size="middle"
            placeholder="提示：您可尝试搜索供应商、商品名称、品牌、规格型号等信息"
            style="height: 30px"
            @keyup.enter.native="goToSearch()"
          ></el-input>
          <eui-btn
            type="primary"
            style="margin-left: 20px; margin-top: 10px"
            @click="goToSearch"
            >搜 索</eui-btn
          >
          <!--          <p @click="goToSearch" class="scroller_btn">搜 索</p>-->
        </div>
      </div>

      <div class="list-wrapper">
        <!-- 面包屑 -->
        <shop-breadcrumb-nav
          :bread-data="breadData"
          :is-mult-bread="isMultBread"
          @removeSelectItem="removeSelectItem"
          @selectSignAndAll="handleSelect"
        ></shop-breadcrumb-nav>
        <!-- 筛选项 -->
        <search-filter
          :filter-data="searchData"
          @selectItem="selectFilterHandle"
          @selectMultItem="multSelectFilterHandle"
        ></search-filter>
      </div>
    </div>
    <div class="list-wrapper">
      <!-- 列表筛选 -->
      <list-filter
        :show-detail="showDetail"
        :list-filter-data="listFilterData"
        :plan-is-open="planIsOpen"
        :check-list="checkList"
        @change="listTapChange"
        @tabChangeHandle="changeHandle"
        @sortByPrice="sortByPrice"
        @selectCheckBox="handleTagSearch"
      ></list-filter>
    </div>
    <div class="application-info-bottom">
      <el-table
        :header-cell-style="{ color: '#333', background: '#f5f5f5' }"
        :data="productList"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="date"
          label="商品信息"
          width="340"
        >
          <template slot-scope="scope">
            <div class="product-info">
              <!-- v-lazy="scope.row.defaultimage" -->
              <img class="product-img" :src="scope.row.defaultimage" alt />
              <!--              <img class="product-img-icon" src="~/assets/images/5.png" alt="">-->
              <div class="product-info-right">
                <div
                  v-if="scope.row.skuname.length < 48"
                  class="title two-line"
                >
                  {{ scope.row.skuname }}
                </div>
                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  :content="scope.row.skuname"
                  placement="top"
                >
                  <div class="title two-line">{{ scope.row.skuname }}</div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.skucode"
                  placement="bottom"
                >
                  <div class="num break">单品编号：{{ scope.row.skucode }}</div>
                </el-tooltip>
                <div class="provider">
                  供应商：{{ scope.row.suppliercompanyname }}
                </div>
                <!--                <div class="footer">-->
                <!--                  <p class="authenticated">已认证</p>-->
                <!--                  <p class="easy-all-pass">易权通</p>-->
                <!--                </div>-->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="brandname"
          label="品牌"
          width="180"
        ></el-table-column>
        <el-table-column align="center" prop="delivertime" label="发货时间">
          <template slot-scope="scope">
            <div>{{ scope.row.delivertime }}天内发货</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="unitvalue"
          label="单位"
        ></el-table-column>
        <el-table-column align="center" label="含税价格（元）">
          <template slot-scope="scope">
            <div
              v-if="scope.row.price && scope.row.pricetype === 4"
              class="jc-price-container"
            >
              <img
                height="20"
                width="44"
                src="../../../../../assets/img/product/together-price-icon-small@2x.png"
                alt="集采价"
              />
              <div class="jc-price">
                ￥
                <span>{{ scope.row.price.toFixed(2) }}</span>
              </div>
            </div>
            <template
              v-else-if="scope.row.priceList && scope.row.priceList.length > 0"
            >
              <span
                v-if="Number(purchaseInfo.remainingQuantity) > 0"
                style="color: #f0250f; font-weight: bold"
              >
                <span
                  v-for="priceItem in scope.row.priceList"
                  v-if="
                    Number(purchaseInfo.remainingQuantity) >=
                      priceItem.startValue &&
                    (priceItem.endValue != undefined
                      ? Number(purchaseInfo.remainingQuantity) <
                        priceItem.endValue
                      : true)
                  "
                  :key="priceItem.priceId"
                  class="p-price"
                >
                  ￥{{ Number(priceItem.price).toFixed(2) }}
                </span>
              </span>
              <span v-else style="color: #f0250f; font-weight: bold">
                <span
                  v-for="priceItem in scope.row.priceList"
                  v-if="
                    Number(purchaseInfo.intqty) >= priceItem.startValue &&
                    (priceItem.endValue != undefined
                      ? Number(purchaseInfo.intqty) < priceItem.endValue
                      : true)
                  "
                  :key="priceItem.priceId"
                  class="p-price"
                >
                  ￥{{ Number(priceItem.price).toFixed(2) }}
                </span>
              </span>
            </template>

            <span v-else style="color: #f0250f; font-weight: bold"
              >￥{{ Number(scope.row.price).toFixed(2) }}</span
            >

            <div
              v-if="scope.row.priceList && scope.row.priceList.length > 0"
              class="step-price"
              @mouseover="
                isShowPriceSheet = true;
                isCurrent = scope.row.productid;
              "
              @mouseleave="
                isShowPriceSheet = false;
                isCurrent = null;
              "
            >
              <!--  <img src="@/assets/img/purchase/icon-stage-price@2x.png" alt="" /> -->
              <span class="icon-question">?</span>
              <transition name="fade">
                <priceSheet
                  v-if="isShowPriceSheet && isCurrent == scope.row.productid"
                  :price-table="scope.row.priceList"
                  :left="left"
                  :top="top"
                ></priceSheet>
              </transition>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <eui-btn type="secondary" @click="selectBtn(scope.row)"
              >选中</eui-btn
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        :total="queryParams.total"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!-- 还未维护计量单位提示 -->
    <e-dialog
      :dialog-title="dialogTitle"
      :dialog-type="''"
      :center-dialog-visible="unitVisible"
      :popup-width="'450px'"
      :show-close="false"
      @submitPopupData="submitPopupData"
      @updateVisible="unitVisible = false"
      @resetPopupData="unitVisible = false"
    >
      <div>您好，所选商品计量单位关系转换还未维护，是否手工维护？</div>
    </e-dialog>
    <!-- 新增计量单位 -->
    <e-dialog
      :dialog-title="addDialogTitle"
      :dialog-type="''"
      :center-dialog-visible="addUnitVisible"
      :popup-width="'500px'"
      :show-close="false"
      @submitPopupData="addPopupData('form')"
      @resetPopupData="handleClose"
    >
      <el-form ref="form" :rules="rules" :model="unitForm" label-width="130px">
        <el-form-item label="采购商计量单位：">
          <el-input v-model="unitForm.purchaseUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="易派客计量单位：">
          <el-input v-model="unitForm.epecUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="转换比例：" prop="proportion">
          <div class="proportion-unit">
            {{ `(${unitForm.purchaseUnit}：${unitForm.epecUnit})` }}
          </div>
          <el-input
            v-model="unitForm.proportion"
            autocomplete="off"
            clearable
            placeholder="请输入转换比例"
            @blur="blurInput($event)"
            @input="limitInput($event, 'proportion')"
          ></el-input>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import priceSheet from '@/modules/projectA/components/purchase/pirce-sheet.vue';
import shopBreadcrumbNav from '@/modules/projectA/components/purchase/shopBreadcrumbNav';
import searchFilter from '@/modules/projectA/components/purchase/searchFilter';
import listFilter from '@/modules/projectA/components/purchase/shopListFilter.vue';
import Api from '@/modules/projectA/api/purchase/index';
import enApi from '@/modules/projectA/api/enquiry/index';

const qs = require('qs');

export default {
  components: {
    eDialog,
    priceSheet,
    shopBreadcrumbNav,
    searchFilter,
    listFilter,
  },
  data() {
    return {
      showDetail: false,
      checkList: [],
      planIsOpen: false,
      listFilterData: {
        total: 0,
      },
      searchData: [],
      breadData: {
        from: 'goodProduct',
        searchTxt: '',
        list: [],
        attrList: [],
        multiArrList: [], // 多选时查看此数组
      },
      isShowPriceSheet: false,
      isCurrent: null,
      top: '-38px',
      left: '-530px',
      searchValue: '',
      routeData: null, // 路由信息
      queryParams: {
        searchtext: '',
        thirdcategory: '',
        attributesList: [],
        specificationsList: [],
        brandname: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        orderBy: null,
        ranking: null,
        categoryIds: [],
        supplierCompanyIds: [],
        specializedSign: 1,
        recommendSign: 0,
        specializedSign: 1, // 专属商城
        isPurchaseZone: 0, // 框架协议商品0   1仅框架协议
        unPlannedSign: 0, // 非计划采购  1 仅非计划采购
      },
      formLabelAlign: {
        name: '',
        region: '',
        type: '',
        test: '',
      },
      unitForm: {
        purchaseUnit: '',
        epecUnit: '',
        proportion: '',
      },
      isMultBread: false, // 是否是多选
      purchaseRow: {},
      records: {},
      baseInfo: {},
      productList: [],
      productSearch: {
        skuname: '', // 精确查询
        searchtext: '', // 模糊查询
        brandname: '', // 品牌
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        suppliercompanyname: '', // 供应商
        unitvalue: '', // 筛选条件
        pageNum: 1,
        pageSize: 10,
      },
      purchaseInfo: Object,
      oldSkuIdList: [],
      prPurchasLlistVOs: [],
      dialogTitle: '计量单位关系转换',
      addDialogTitle: '新增计量单位转换',
      unitVisible: false,
      addUnitVisible: false,
      rules: {
        proportion: [
          { required: true, message: '请输入转换比例', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.purchaseRow = this.$route.query;
    this.records = JSON.parse(
      localStorage.getItem('purchaseWayExecuteRecords')
    );
    this.queryDetail();
    this.getProductPage();
    this.queryPurchasePlanItemDetail();
  },
  methods: {
    // 优选、认证、易权通标识搜索
    handleTagSearch(options) {
      this.queryParams.pageNum = 1;
      if (options.indexOf(1) != -1) {
        // 推荐商品
        this.queryParams.tags = [1];
      } else {
        this.queryParams.tags = [];
      }
      if (options.indexOf(2) != -1) {
        // 协议商品
        this.queryParams.isPurchaseZone = 1;
      } else {
        this.queryParams.isPurchaseZone = 0;
      }
      if (options.indexOf(3) != -1) {
        // 可用易权通
        this.queryParams.ebillsign = 1;
      } else {
        this.queryParams.ebillsign = '';
      }
      if (options.indexOf(4) > -1) {
        // 非计划商品
        this.queryParams.unPlannedSign = 1;
      }
      if (options.indexOf(5) > -1) {
        // 非计划商品
        this.queryParams.unPlannedSign = 0;
      }
      if (options.indexOf(6) > -1) {
        // 优品推荐
        this.queryParams.recommendSign = 1;
      } else {
        this.queryParams.recommendSign = 0;
      }
      this.getProductPage();
    },
    sortByPrice(options, type) {
      this.queryParams.pageNum = 1;
      if (type == 'price') {
        this.queryParams.orderBy = 'price';
        this.queryParams.ranking = options;
      } else if (type == 'area') {
        this.queryParams.pageNum = 1;
        this.queryParams.areacode = options;
      }
      this.getProductPage();
    },
    // tab切换
    changeHandle(options) {
      this.queryParams.pageNum = 1;
      if (options == '默认') {
        this.queryParams.orderBy = null;
        this.queryParams.ranking = null;
        this.getProductPage();
      } else if (options == '销量') {
        this.queryParams.orderBy = 'salesvolume';
        this.queryParams.ranking = '2';
        this.getProductPage();
      } else if (options == '产品质量评价') {
        this.queryParams.orderBy = 'productevaluate';
        this.queryParams.ranking = '2';
        this.getProductPage();
      }
    },
    // 列表切换
    listTapChange(data) {
      if (data === 'small') {
        this.isBigImg = false;
      } else {
        this.isBigImg = true;
      }
    },
    // 多选搜索
    async multSelectFilterHandle(options) {
      this.isMultBread = true;
      if (options.type == 'attr') {
        const { attributesList } = this.queryParams;

        if (attributesList.length == 0) {
          options.multiArr.map((item) => {
            this.queryParams.attributesList.push(item);
          });
        } else {
          const temList = [];
          for (let i = 0; i < attributesList.length; i++) {
            if (attributesList[i].indexOf(options.name) == -1) {
              temList.push(attributesList[i]);
            }
          }
          this.queryParams.attributesList = temList;
          options.multiArr.map((item) => {
            this.queryParams.attributesList.push(item);
          });
        }
      }
      if (options.type == 'spec') {
        const { specificationsList } = this.queryParams;
        if (specificationsList.length == 0) {
          options.multiArr.map((item) => {
            this.queryParams.specificationsList.push(item);
          });
        } else {
          for (let j = 0; j < specificationsList.length; j++) {
            if (specificationsList[j].indexOf(options.name) != -1) {
              specificationsList.splice(j, 1);
            }
          }
          options.multiArr.map((item) => {
            this.queryParams.specificationsList.push(item);
          });
        }
      }
      if (options.type == 'brand') {
        this.queryParams.brandnames = options.multiArr;
      }
      const { multiArrList } = this.breadData;

      if (multiArrList.length == 0) {
        this.breadData.multiArrList.push({
          name: options.name,
          typeName: options.type,
          list: options.multiArr,
        });
      } else {
        // for (let i = 0; i < multiArrList.length; i++) {
        //   if (multiArrList[i].name == options.name && multiArrList[i].typeName == options.type) {
        //     this.breadData.multiArrList[i].list = options.multiArr;
        //   } else {
        //     this.breadData.multiArrList.push({
        //       name: options.name,
        //       typeName: options.type,
        //       list: options.multiArr,
        //     });
        //   }
        // }
        this.multSelectFilterHandle(multiArrList, options);
      }

      this.queryParams.pageNum = 1;
      if (
        !this.queryParams.hasOwnProperty('unPlannedSign') &&
        this.planIsOpen
      ) {
        this.queryParams.unPlannedSign = 0;
      }
      const res = await enApi.queryProductPage(this.queryParams);

      if (res.success) {
        this.productList = res.data.list;
        this.listFilterData.total = res.data.total;
        this.queryParams.total = res.data.total;
        this.searchData = this.assembleFilterData(res.data);
      }
      const { searchData } = this;
      // for (let i = 0; i < searchData.length; i++) {
      //   if (searchData[i].type == options.type && options.type == 'cate') {
      //     searchData[i].isShow = false;
      //   }
      // }
      this.updateSearchData(searchData, options);
    },
    updateSearchData(searchData, options) {
      for (let i = 0; i < searchData.length; i++) {
        if (searchData[i].type == options.type && options.type == 'cate') {
          searchData[i].isShow = false;
        }
      }
    },
    // 降低复杂度提取方法 组装面包屑数据
    assembleMultiArrList(multiArrList, options) {
      let flag = true;
      for (let i = 0; i < multiArrList.length; i++) {
        if (
          multiArrList[i].name == options.name &&
          multiArrList[i].typeName == options.type
        ) {
          this.breadData.multiArrList[i].list = options.multiArr;
          flag = false;
        }
      }
      if (flag) {
        this.breadData.multiArrList.push({
          name: options.name,
          typeName: options.type,
          list: options.multiArr,
        });
      }
    },
    // 判断是否已经选过
    checkDuplicate(arr, name, type) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].name == name && arr[i].typeName == type) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    // 判断查询数据中是否已选过
    checkDuplicateAttr(arr, name) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == name) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    // 搜索项触发事件
    async selectFilterHandle(options) {
      this.isloading = true;
      const route = this.$route.query;
      if (options.type == 'cate' || options.type == 'brand') {
        switch (options.type) {
          case 'cate':
            this.queryParams.category = options.val;
            break;
          case 'brand':
            this.queryParams.brandname = options.val;
            break;
          default:
            break;
        }
        this.assembleBreadDataBySelected(
          route.from,
          options.val,
          options.type,
          options.filterName
        );
      }

      if (options.type == 'attr') {
        const name = `${options.filterName}_${options.val.value}`;
        if (
          !this.checkDuplicateAttr(
            this.queryParams.attributesList,
            name,
            options.type
          )
        ) {
          this.queryParams.attributesList.push(name);
        } else {
          return;
        }
        this.assembleBreadDataBySelected(
          route.from,
          options.val.value,
          options.type,
          options.filterName
        );
      }
      if (options.type == 'spec') {
        const name = `${options.filterName}_${options.val.value}`;
        if (
          !this.checkDuplicateAttr(
            this.queryParams.specificationsList,
            name,
            options.type
          )
        ) {
          this.queryParams.specificationsList.push(name);
        } else {
          return;
        }

        this.assembleBreadDataBySelected(
          route.from,
          options.val.value,
          options.type,
          options.filterName
        );
      }
      this.queryParams.pageNum = 1;
      if (
        !this.queryParams.hasOwnProperty('unPlannedSign') &&
        this.planIsOpen
      ) {
        this.queryParams.unPlannedSign = 0;
      }
      const res = await enApi.queryProductPage(this.queryParams);

      if (res.code == 200) {
        this.productList = res.data.list;
        this.listFilterData.total = res.data.total;
        this.queryParams.total = res.data.total;
        this.searchData = this.assembleFilterData(res.data);
      }
      const { searchData } = this;
      for (let i = 0; i < searchData.length; i++) {
        if (searchData[i].type == options.type && options.type == 'cate') {
          searchData[i].isShow = false;
        }
      }
    },

    // 筛选拼装breadcrumb数据
    assembleBreadDataBySelected(routeForm, value, type, filterName) {
      if (routeForm != 'index') {
        if (!this.checkDuplicate(this.breadData.attrList, value, type)) {
          this.breadData.attrList.push({
            name: value,
            type: filterName,
            typeName: type,
          });
        } else {
          this.isloading = false;
        }
      } else if (!this.checkDuplicate(this.breadData.list, value, type)) {
        this.breadData.list.push({
          name: value,
          type: filterName,
          typeName: type,
        });
      } else {
        this.isloading = false;
      }
    },
    // 去除面包屑选中样式
    async removeSelectItem(options, isMult) {
      const list =
        this.routeData && this.routeData.from == 'index'
          ? this.breadData.list
          : this.breadData.attrList;
      for (let i = 0; i < list.length; i++) {
        if (
          list[i].type == options.type &&
          list[i].name == options.name &&
          list[i].typeName == options.typeName
        ) {
          list.splice(i, 1);
          break;
        }
      }
      if (options.typeName == 'cate') {
        this.queryParams.category = '';
        this.queryParams.categoryIds = this.categoryIdList;
      }
      if (options.typeName == 'brand') {
        if (isMult == true) {
          this.queryParams.brandnames = [];

          this.deleteBreadcrumbNavBrandOrSupplier('brand');
        } else {
          this.queryParams.brandname = '';
        }
      }
      if (options.typeName == 'attr') {
        const { attributesList } = this.queryParams;

        if (isMult == true) {
          // 更新搜索的属性
          this.queryParams.attributesList = productUtils.removeSameItem(
            attributesList,
            options.list
          );
          this.deleteBreadcrumbNavAttrOrSpecByMult('attr', options);
        } else {
          this.deleteBreadcrumbNavAttrOrSpec(
            this.queryParams.attributesList,
            options
          );
        }
      }
      if (options.typeName == 'spec') {
        const { specificationsList } = this.queryParams;
        if (isMult == true) {
          // 更新搜索的属性
          this.queryParams.specificationsList = productUtils.removeSameItem(
            specificationsList,
            options.list
          );
          // 更新面包屑筛选框
          this.deleteBreadcrumbNavAttrOrSpecByMult('spec', options);
        } else {
          this.deleteBreadcrumbNavAttrOrSpec(
            this.queryParams.specificationsList,
            options
          );
        }
      }
      // this.getProductPage();

      // 如果多选参数为空后隐藏多选边框
      if (this.breadData.multiArrList.length == 0) this.isMultBread = false;
      if (
        !this.queryParams.hasOwnProperty('unPlannedSign') &&
        this.planIsOpen
      ) {
        this.queryParams.unPlannedSign = 0;
      }
      const res = await enApi.queryProductPage(this.queryParams);

      if (res.code == 200) {
        this.productList = res.data.list;
        this.searchData = this.assembleFilterData(res.data);
        this.listFilterData.total = res.data.total;
        this.queryParams.total = res.data.total;
      }
      const { searchData } = this;
      this.updateSearchDataInRemoveSelectItem(searchData, options);
    },
    // 降低复杂度 searchData重置
    updateSearchDataInRemoveSelectItem(searchData, options) {
      for (let i = 0; i < searchData.length; i++) {
        if (
          searchData[i].type == options.typeName &&
          options.typeName == 'cate'
        ) {
          searchData[i].isShow = true;
        }
      }
    },
    // 删除面包屑供应商和品牌多选
    deleteBreadcrumbNavBrandOrSupplier(type) {
      const { multiArrList } = this.breadData;
      for (let i = 0; i < multiArrList.length; i++) {
        if (multiArrList[i].typeName === type) {
          multiArrList.splice(i, 1);
        }
      }
    },
    // 规格属性单选时删除方法
    deleteBreadcrumbNavAttrOrSpec(arr, options) {
      for (let j = 0; j < arr.length; j++) {
        if (
          arr[j].indexOf(options.type) != -1 &&
          arr[j].indexOf(options.name) != -1
        ) {
          arr.splice(j, 1);
          break;
        }
      }
    },
    // 规格属性多选时删除方法
    deleteBreadcrumbNavAttrOrSpecByMult(type, options) {
      const { multiArrList } = this.breadData;
      for (let i = 0; i < multiArrList.length; i++) {
        if (
          multiArrList[i].typeName === type &&
          multiArrList[i].name === options.name
        ) {
          multiArrList.splice(i, 1);
        }
      }
    },
    // 组装筛选数据
    assembleFilterData(obj) {
      const arr = [];
      if (obj.list.length == 0) {
        return arr;
      }
      if (
        obj.category.length > 0 &&
        this.routeData &&
        this.routeData.from == undefined
      ) {
        arr.push({
          name: '目录',
          type: 'cate',
          isShow: obj.category.length > 0,
          fitem: obj.category,
        });
      }
      if (obj.brandname_literal.length > 0) {
        arr.push({
          name: '品牌',
          type: 'brand',
          isShow: true,
          fitem: obj.brandname_literal,
        });
      }

      for (const key in obj.attributes) {
        arr.push({
          name: key,
          type: 'attr',
          isShow: true,
          fitem: obj.attributes[key],
        });
      }
      for (const key in obj.specifications) {
        arr.push({
          name: key,
          type: 'spec',
          isShow: true,
          fitem: obj.specifications[key],
        });
      }

      return arr;
    },
    handleSelect(val) {
      if (val == 1) {
        this.queryParams.categoryIds = [];
        this.queryParams.supplierCompanyIds = [];
        this.queryParams.isPurchaseZone = 1;
      } else {
        // let categoryIdList = JSON.parse(localStorage.getItem('categoryIdList'));
        // let supplierCompanyIds = JSON.parse(localStorage.getItem('companyIdList'));
        this.queryParams.isPurchaseZone = 0;
        this.queryParams.categoryIds = categoryIdList;
        this.queryParams.supplierCompanyIds = supplierCompanyIds;
      }
      this.getProductPage();
    },
    async getProductPage() {
      if (
        !this.queryParams.hasOwnProperty('unPlannedSign') &&
        this.planIsOpen
      ) {
        this.queryParams.unPlannedSign = 0;
      }
      const time = new Date().getTime();
      const res = await enApi.queryProductPage(this.queryParams);
      if (res.code == 200) {
        // this.productList = res.data.list;
        this.queryParams.time = time;
        this.queryParams.total = res.data.total;
        this.queryParams.randomId =
          this.queryParams.time.toString() +
          Math.floor(Math.random() * 1000000 + 1);

        // this.clickSearchEvent()

        this.productList = this.addQuantityItem(res.data.list);
        if (this.productList.length == 0) {
          this.showEmpty = true;
        } else {
          this.showEmpty = false;
        }
        //  this.$set(this.productList,this.addQuantityItem(res.data.list));
        this.searchData = this.assembleFilterData(res.data);
        this.listFilterData.total = res.data.total;
      }
    },
    // 增加数量字段
    addQuantityItem(arr) {
      // if(arr.length<=0)return
      arr.map((item) => {
        item.quantity = 0;
      });

      return arr;
    },
    // 搜索
    goToSearch() {
      if (this.productSearch.searchtext.trim().length > 100) {
        this.$message.warning('搜索词不能超过100个字');
        return;
      }
      this.queryParams.pageNum = 1;
      this.queryParams.searchtext = this.productSearch.searchtext;
      this.breadData.searchTxt = this.productSearch.searchtext;
      this.queryProductPage();
    },
    resetBtn() {
      this.productSearch = {
        searchtext: '',
        skuname: '',
        brandname: '', // 品牌
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        companyName: '', // 供应商
        // unitvalue: this.purchaseInfo.epecBaseUnitName ?  this.purchaseInfo.epecBaseUnitName :'',
        unitvalue: '',
        pageNum: 1,
        pageSize: 10,
      };
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.queryProductPage();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.queryProductPage();
    },
    onSubmit() {},
    async queryDetail() {
      const res = await Api.queryProductPage2(this.productSearch);
      if (res.code == '200') {
        this.purchaseInfo = res.data;
        //  if(res.data.epecBaseUnitName){
        //    this.productSearch.unitvalue = res.data.epecBaseUnitName;
        //  }
      }
      this.queryProductPage();
    },
    async queryProductPage() {
      const res = await enApi.queryProductPage({
        ...this.productSearch,
        ...this.queryParams,
      });
      if (res.code == '200') {
        this.productList = res.data.list;
        this.queryParams.total = res.data.total;
        this.listFilterData.total = res.data.total;
        this.searchData = this.assembleFilterData(res.data);
      }
      const stepReq = [];
      // 封装阶梯价 数据
      this.productList.forEach((item) => {
        stepReq.push({
          supplierCompanyId: item.suppliercompanyid,
          skuId: item.skuid,
        });
      });
      const stepRes = await Api.getStepPrice(stepReq); // 获取阶梯价
      if (stepRes.code == 200) {
        const stepData = stepRes.data;
        this.productList.forEach((item) => {
          stepData.forEach((stepItem) => {
            if (item.skuid == stepItem.skuId) {
              this.$set(item, 'priceList', stepItem.stepPriceList);
              // item.priceList = stepItem.stepPriceList ;
            }
          });
        });
      }
    },
    async selectProduct(val) {
      const userInfo = this.$store.state.USERINFO;
      // 获得税率信息
      const param = {
        taxRateId: val.taxrateid,
      };
      const res1 = await Api.getProductRate(param);

      if (res1.code === '200') {
        this.taxInfo = res1.data;

        const params = {
          brandName: val.brandname, // 品牌
          categoryId: val.categoryid, // 商品类目ID
          categoryName: val.category, // 商品类目名称
          price: val.price, // 商品价格
          productId: val.productid, // 商品id
          productImageUrl: val.defaultimage, // 商品图片
          productSkuCode: val.skucode, // 货品编号
          productSkuId: val.skuid, // 货品ID
          productSkuName: val.skuname, // 商品名称
          productSkuOptions: val.specificationsList, // 规格字符串 数组
          productSkuOptionsStr: val.specificationstr, // 规格字符串 拼接
          conversionUnitRatio: '', // 计量单位转换比率
          salesTaxNo: this.taxInfo.taxRateCode, // 销售税码
          salesTaxRate: this.taxInfo.taxRate, // 销售税率
          supplierCompanyId: val.suppliercompanyid, // 供应商公司id
          supplierCompanyName: val.suppliercompanyname, // 供应商公司名称
          purchaseCompanyId: userInfo.companyId, // 采购商id
          purchaseCompanyName: userInfo.companyName, // 采购商名称
          unitName: val.unitvalue, // 商品计量单位名称
          createMemberId: userInfo.memberId, // 申请人ID
          createMemberName: userInfo.memberName, // 申请人真实姓名
          createTime: this.records.createTime, // 创建时间
          protocolCode: this.records.protocolCode, // 协议编码
          protocolId: this.records.protocolId, // 协议ID
          purchasePlanId: this.purchaseRow.purchasePlanId, // 采购计划id
          purchasePlanItemId: this.purchaseRow.purchasePlanItemId, // 采购计划物料明细id
          purchaseQuantity: this.baseInfo.quantity, // 采购数量
          subtotal: this.baseInfo.quantity * val.price, // 小计
          unitCode: '', // 商品计量单位编码
          purchasePlanItemSkuId: val.skuid, // 采购计划商品明细id
          deleteStatus: '', // 删除标记 默认 0：有效 1：删除
          updateMemberId: userInfo.memberId, // 申请人ID
          updateMemberName: userInfo.memberName, // 申请人真实姓名
          updateTime: '', // 修改时间
        };

        if (val.pricetype === 4) {
          const agrParams = {
            skuId: val.skuid,
            supplierCompanyId: val.suppliercompanyid,
            priceType: 4,
          };
          const result = await Api.queryAgreementCodeByType(agrParams);
          if (result.code === '200') {
            const [newAgreementCode] = result.data;
            params.sinoProtocol = newAgreementCode;
            params.protocolCode = newAgreementCode;
            params.priceType = val.pricetype;
          }
        }

        console.log(params, '提交参数');
        const res = await Api.checkPlanItemSku(params);

        if (res.code == '200') {
          this.$router.back();
        }
      }
    },
    // 组装加入购物车规格属性参数
    assembleCartParams(arr, name, value) {
      // console.log(arr);
      const res = [];
      if (arr.length == 0) return res;
      for (let i = 0; i < arr.length; i++) {
        const temObj = {};
        const index = arr[i].indexOf('_');
        temObj[name] = arr[i].substr(0, index);
        temObj[value] = arr[i].substr(index + 1);
        res.push(temObj);
      }
      // console.log(res);
      return res;
    },
    changePriceSheetShow(index) {
      this.$set(this.productList[index], isShowPriceSheet, true);
    },
    changePriceSheetHidden(index) {
      this.$set(this.productList[index], isShowPriceSheet, false);
    },
    selectBtn(data) {
      this.selectProduct(data);
    },

    // 手动维护计量单位
    submitPopupData() {
      this.unitVisible = false;
      this.addUnitVisible = true;
    },

    handleClose() {
      this.addUnitVisible = false;
      this.$refs.form.resetFields();
    },

    blurInput(e) {
      const val = e.target.value;
      if (val == 0) {
        this.unitForm.proportion = '';
      }
    },
    limitInput(value, name) {
      this.unitForm[name] =
        `${value}` // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,4})/g)[0] || ''; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到4位小数
    },
    // 新增计量单位转换
    addPopupData(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const params = {
            sourceUnit: this.unitForm.purchaseUnit,
            targetUnit: this.unitForm.epecUnit,
            conversionRatio: this.unitForm.proportion,
            companyId: this.$store.state.USERINFO.companyId,
            companyName: this.$store.state.USERINFO.companyName,
            sysNo: this.$store.state.USERINFO.internalCode,
          };
          Api.addConversionUnit(params).then((res) => {
            if (res.code == '200') {
              this.addUnitVisible = false;
              this.$message.success('提交成功');
              this.queryDetail();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async queryPurchasePlanItemDetail() {
      const res = await Api.queryPurchasePlanItemDetail({
        purchasePlanItemId: this.purchaseRow.purchasePlanItemId,
      });
      if (res.code === '200') {
        this.baseInfo = res.data || {};
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/css/theme.scss';
::v-deep .jc-price-container {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  img {
    position: relative;
    z-index: 1;
  }
  .jc-price {
    height: 18px;
    padding: 0 10px 0 20px;
    margin-left: -20px;
    align-self: flex-end;
    background: #ffeac9;
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    color: #f0250f;
  }
}
.application-info-container {
  background: #fff;
  color: $font-color-text;
  margin-bottom: 20px;
  ::v-deep .container .content {
    padding: 0;
    overflow: visible;
  }

  ::v-deep .list-wrapper {
    .container {
      box-shadow: none;
      content {
        padding: 0;
        width: 100%;
      }
    }
    .content {
      padding: 0;
      overflow: visible;
    }
  }

  ::v-deep .el-input__inner {
    color: #333;
  }
  .application-info-top {
    margin-bottom: 20px;

    .application-info-top-header {
      font-weight: bold;
      padding-left: 20px;
      height: 40px;
      border: 1px solid #d9d9d9;
      border-bottom: none;
      line-height: 40px;
      color: $font-color-text;
      background-color: $main-table-th-bg;
      box-sizing: border-box;
    }

    .application-info-top-content-container {
      display: flex;
      flex-direction: column;
      padding: 20px 20px 10px 60px;
      border: 1px solid $border-color;
      box-sizing: border-box;

      .application-info-top-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        > div {
          width: 300px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .application-info-middle {
    margin-bottom: 20px;
    border: 1px solid $border-color;
    box-sizing: border-box;
    .list-wrapper {
      .content {
        padding: 0;
        overflow: visible;
      }
    }
    .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-top: 15px;
      .enquiry_btn {
        width: 100px;
        height: 34px;
        line-height: 30px;
        background: #2587ff;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border: 2px solid $main-col;
        &:hover {
          background-color: #126edf;
          border-color: #126edf;
        }
      }
    }

    .application-info-middle-header {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #d9d9d9;
      color: $font-color-text;
      background: $main-table-th-bg;
      box-sizing: border-box;

      div:nth-child(1) {
        font-weight: bold;
      }

      span {
        color: $headline-color-num;
      }
    }
    .scroller_right {
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      .scroller_input {
        width: 514px;
        ::v-deep.el-input__inner {
          border: 1px solid $main-col;
          border-right: none;
          border-radius: 0;
          height: 34px;
          line-height: 34px;
          font-size: 12px;
        }
      }
      .scroller_btn {
        width: 100px;
        height: 34px;
        line-height: 30px;
        background: #2587ff;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border: 2px solid $main-col;
        &:hover {
          background-color: #126edf;
          border-color: #126edf;
        }
      }
    }
    .application-info-middle-content-container {
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 0 38px;
      box-sizing: border-box;

      .application-info-middle-content-left {
        flex: 0 1 924px;

        ::v-deep .el-form {
          margin-top: -14px;
          .el-form-item {
            margin-bottom: 0;
            .el-form-item__content {
              .el-col {
                .el-input {
                  input {
                    width: 190px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .application-info-middle-content-right {
      display: flex;
      justify-content: center;
      margin: 7px 0 10px 0;
      .reset-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #e8efff;
        color: #2587ff;
        cursor: pointer;
        border: 1px solid #2587ff;
        margin-right: 20px;
        &:hover {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #2587ff;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background-color: #126edf;
        }
      }
    }
  }

  .application-info-bottom {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;

    ::v-deep .el-table {
      .product-info {
        position: relative;
        display: flex;
        align-items: center;
        width: 340px;

        .product-img {
          width: 88px;
          height: 88px;
          border: 1px solid #e2e2e2;
          box-sizing: border-box;
        }

        .product-img-icon {
          position: absolute;
          top: 11px;
          left: 6px;
          width: 20px;
          height: 20px;
        }

        .product-info-right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          > div {
            align-self: flex-start;
          }

          .title {
            width: 220px;
            text-align: left;
            color: #333333;
          }

          .num {
            font-size: 12px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 231px;
            text-align: start;
          }

          .provider {
            font-size: 12px;
            color: #666666;
          }

          .footer {
            display: flex;
            justify-content: flex-start;

            p {
              width: 48px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #ffffff;
              margin-left: 10px;
              border-radius: 5px;
              font-size: 12px;
            }

            .authenticated {
              background-color: $button-background-color;
            }

            .easy-all-pass {
              background-color: $button-background-color2;
            }
          }
        }
      }

      .select-btn {
        width: 80px;
        height: 30px;
        line-height: 26px;
        color: #2587ff;
        border: 1px solid #2587ff;
        background-color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #2587ff;
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-table .cell {
  overflow: visible;
}

.step-price {
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: center;
  &:hover {
    .price-sheet {
      display: inline-block;
    }
  }
  cursor: pointer;
  img {
    width: 45px;
    margin: 0 4px 0 8px;
  }
  .icon-question {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    .icon-question {
      background: #c5c5c5;
      color: #fff;
    }
  }
}
::v-deep .el-input {
  width: 200px;
  border-radius: 0;
}
::v-deep .el-input__inner {
  border-radius: 0;
}
::v-deep .el-form-item__content {
  position: relative;
}
.proportion-unit {
  position: absolute;
  left: -140px;
  top: 28px;
  width: 120px;
  height: 30px;
  text-align: right;
  word-wrap: break-word;
  word-break: break-all;
  line-height: normal;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  ::v-deep .el-input {
    border-radius: 0;
    width: 80px;
  }
}
</style>
